// section-base.js — Section lifecycle base class
// Replaces the ~80-line minified block duplicated in every Process Creative section file
(function() {
  'use strict';

  class Section {
    constructor(container) {
      this.container = container;
      this.children = {};
      this.events = [];
      this.observers = [];
      this.swipers = [];
    }

    // Override in subclass: query DOM children into this.children
    queryChildren() {}

    // Override in subclass: set up initial state
    init() {}

    // Override in subclass: bind event listeners
    attachEvents() {}

    // Override in subclass: cleanup
    dispose() {
      this.events.forEach(({ el, type, handler }) => el.removeEventListener(type, handler));
      this.events = [];
      this.observers.forEach(obs => obs.disconnect());
      this.observers = [];
      this.swipers.forEach(s => { try { s.destroy(true, true); } catch(e) {} });
      this.swipers = [];
    }

    // Helper: register event listener with auto-cleanup
    on(el, type, handler, options) {
      if (!el) return;
      el.addEventListener(type, handler, options);
      this.events.push({ el, type, handler });
    }

    // Helper: querySelector shorthand
    q(selector) { return this.container.querySelector(selector); }
    qAll(selector) { return [...this.container.querySelectorAll(selector)]; }

    // Replace inner HTML and re-initialize (for Shopify section rendering API)
    replaceContainer(newContainer) {
      this.dispose();
      this.container = newContainer;
      this.children = {};
      this.queryChildren(this.container);
      this.init();
      this.attachEvents();
    }

    // Called when Shopify replaces section HTML via AJAX
    onInnerHtmlMutationObserved(newContainer) {
      this.replaceContainer(newContainer);
    }

    // Factory: register a section class for a data-attribute selector
    static register(selector, SectionClass) {
      const initSection = (container) => {
        if (container.hasAttribute('data-section-initialized')) return;
        container.setAttribute('data-section-initialized', '');
        const instance = new SectionClass(container);
        instance.queryChildren(container);
        instance.init();
        instance.attachEvents();
        container._sectionInstance = instance;

        // Watch for Shopify section replacement (theme editor / AJAX)
        const observer = new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.type === 'childList' && m.addedNodes.length) {
              instance.onInnerHtmlMutationObserved(container);
              break;
            }
          }
        });
        observer.observe(container, { childList: true });
        instance.observers.push(observer);
      };

      // Init existing elements
      document.querySelectorAll(selector).forEach(initSection);

      // Watch for dynamically added sections (e.g., Shopify theme editor)
      const bodyObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          m.addedNodes.forEach(node => {
            if (node.nodeType !== 1) return;
            if (node.matches && node.matches(selector)) initSection(node);
            node.querySelectorAll && node.querySelectorAll(selector).forEach(initSection);
          });
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.Section = Section;
})();
